
import CertificationCard from "../Cards/CertificationCard";
import { certifications } from "../../data/constants";
import {
  CardContainer,
  Container,
  Title,
  Wrapper,
} from "../CommonStyles/CardsContainer";

const Certifications = ({ setOpenModalCertification }) => {
  return (
    <Container id="certifications">
      <Wrapper>
        <Title>Certifications</Title>
        <CardContainer>
          {certifications.map((certification, index) => (
            <CertificationCard
              key={index}
              certification={certification}
              setOpenModalCertification={setOpenModalCertification}
            />
          ))}
        </CardContainer>
      </Wrapper>
    </Container>
  );
};

export default Certifications;
